import React, { useState, useEffect } from "react";
import { Modal, FormGroup } from "react-bootstrap";
import BarLoader from "react-spinners/BarLoader";
import { ApplicationWithId } from "../../../../../../contexts/applications-context/ApplicationsContext";
import OutlineButton from "../../../../../../shared/components/ui/outline-button/OutlineButton";

interface IProps {
  show: boolean;
  application: ApplicationWithId;
  onReject(application: ApplicationWithId): void;
  onHide?(): void;
  readOnly?: boolean;
  loading: boolean;
}

interface IState {
  loading: boolean;
  rejectText: string;
}

const RejectDialog = (props: IProps) => {
  const initialState: IState = {
    loading: props.loading,
    rejectText: props.application.remarks || "",
  };

  useEffect(() => {
    setState((ps) => ({ ...ps, loading: props.loading }));
  }, [props.loading]);

  useEffect(() => setState((ps) => ({ ...ps, rejectText: "" })), [props.show]);
  const [state, setState] = useState(initialState);

  return (
    <Modal show={props.show} size="lg" centered onHide={props.onHide}>
      <Modal.Body className={state.loading ? "p-4" : "px-5 pb-5 pt-4"}>
        {state.loading && (
          <BarLoader
            height={4}
            width={"100%"}
            color={"#006699"}
            loading={state.loading}
          />
        )}

        {!state.loading && (
          <>
            <FormGroup className="text-right">
              {props.readOnly && (
                <button className="app-button" onClick={props.onHide}>
                  Close
                </button>
              )}
            </FormGroup>
            {!props.readOnly && (
              <FormGroup>
                <p>Are you sure you want to reject the application?</p>
              </FormGroup>
            )}
            <FormGroup>
              <label
                className="font-weight-bold"
                style={{ color: "#646464", fontSize: "16px" }}
              >
                Remark:
              </label>
              {!props.readOnly ? (
                <textarea
                  className="app-input"
                  style={{ minHeight: "160px", maxHeight: "300px" }}
                  value={state.rejectText}
                  onChange={(e) =>
                    setState({ ...state, rejectText: e.target.value })
                  }
                />
              ) : (
                <p>{props.application.remarks}</p>
              )}
            </FormGroup>
            {!props.readOnly && (
              <FormGroup className="text-right mb-0">
                <OutlineButton
                  color={"gray"}
                  onClick={() => {
                    props.onHide && props.onHide();
                  }}
                >
                  Cancel
                </OutlineButton>
                <span className="p-2"></span>
                <OutlineButton
                  color={"red"}
                  onClick={() => {
                    const application = props.application;
                    application.remarks = state.rejectText;
                    !props.loading && props.onReject(application);
                    // setState({ ...state, loading: true });
                  }}
                  disabled={state.loading}
                >
                  Reject
                </OutlineButton>
              </FormGroup>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default RejectDialog;
